<app-custom-select-atom
  [items]="onSiteLocations"
  *ngIf="displayOnSiteLocationSelect"
  [selectedItem]="selectedOnSiteLocationId"
  (selectItem)="onOnSiteLocationChanged($event)"
  [isDisable]="!!(basketUserId$ | async) && (basketUserId$ | async) !== (userId$ | async)"
></app-custom-select-atom>
